/* import __COLOCATED_TEMPLATE__ from './address.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import getPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code';
import assert, { assertInstanceOf, assertNonNullable } from '@banking/ui/utils/assert';
import { TextField } from 'field-kit';
import { FieldIdentifier } from '@banking/ui/models/common/address';
import * as countryAddressDataUtil from '@banking/ui/utils/country-address-data';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
var AdministrativeAreaField = /*#__PURE__*/function (AdministrativeAreaField) {
  AdministrativeAreaField[AdministrativeAreaField["NONE"] = 0] = "NONE";
  AdministrativeAreaField[AdministrativeAreaField["INPUT_TEXT"] = 1] = "INPUT_TEXT";
  AdministrativeAreaField[AdministrativeAreaField["SELECT"] = 2] = "SELECT";
  return AdministrativeAreaField;
}(AdministrativeAreaField || {});
let Address = (_class = class Address extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    // "static" properties
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
    _defineProperty(this, "AdministrativeAreaField", AdministrativeAreaField);
  }
  get addressCountry() {
    const countryCode = assertNonNullable(this.args.countryAddressData.countryCode);
    const country = assertNonNullable(Country[countryCode]);
    return country;
  }
  get postalCodeFormatter() {
    return getPostalCodeFormatter(this.addressCountry);
  }

  // formats postal code when there is an init value and when the postalCode property changes.
  get formattedPostalCode() {
    return this.args.postalCode != null ? this.postalCodeFormatter.format(this.args.postalCode) : '';
  }
  get postalCodeLabel() {
    return this.intl.t(countryAddressDataUtil.postalCodeLabelTranslationKey(this.args.countryAddressData.postalCodeLabel));
  }
  get administrativeAreaLabel() {
    return this.intl.t(countryAddressDataUtil.admin1LabelTranslationKey(this.args.countryAddressData.admin1Label, this.addressCountry));
  }
  get localityLabel() {
    return this.intl.t(countryAddressDataUtil.localityLabelTranslationKey(this.args.countryAddressData.localityLabel));
  }
  /** *
   * For UK addresses, administrative area is an optional text field labeled "County"
   * For US/CA addresses, it's a dropdown of states, with predefined values from countryAddressData.admin1Values
   */
  get administrativeAreaField() {
    if (this.addressCountry === Country.GB) {
      return AdministrativeAreaField.INPUT_TEXT;
    } else if (this.args.countryAddressData.admin1Values?.length > 0) {
      return AdministrativeAreaField.SELECT;
    } else {
      return AdministrativeAreaField.NONE;
    }
  }
  async initializeFieldKit(fieldCandidate, marketInputTextElement) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in FieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const fieldIdentifier = fieldCandidate;
    const inputElement = await marketInputTextElement.getInputElement();
    const fieldKit = new TextField(inputElement, this.postalCodeFormatter);
    const textDidChange = field => this.args.onValueChange(fieldIdentifier, field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }
  onInputChange(fieldCandidate, event) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in FieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const fieldIdentifier = fieldCandidate;
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    this.args.onValueChange(fieldIdentifier, val);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype), _class);
export { Address as default };